module.exports = __webpack_public_path__ + "img/5.d6673d32.png";